var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-icon',{attrs:{"icon":_vm.icon,"variant":_vm.variant,"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }